import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { environment } from '../../../environments/environment';
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { LocalStorageUtil } from "@utils/localstorage";

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private domain: string;
  private readonly endpointBase: string = 'auth/';
  private readonly apiKey: string;
  private readonly defaultHttpHeaders: HttpHeaders;

  constructor(
    private http: HttpClient,
    private localstorage: LocalStorageUtil,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.domain = `${environment.API_BASE_URL}${environment.version}`;
    this.apiKey = environment.API_KEY;
    this.defaultHttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': `auth-${this.apiKey}`
    });
  }

  private async makePostRequest(path: string, data: any): Promise<any> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.reject('Server Side Rendering: HTTP requests are not allowed on the server for this operation.');
    }

    const currentUrl = this.document.location.href;
    const urlParams = new URLSearchParams(currentUrl.split('?')[1] || '');
    let baseUrlForRequest: string;

    if (environment.ENVIRONMENT_NAME != 'production') {
      baseUrlForRequest = `${environment.API_BASE_URL}`;
    } else {
      baseUrlForRequest = this.domain;
    }

    const requestUrl = new URL(`${baseUrlForRequest}${this.endpointBase}${path}`);

    if (environment.ENVIRONMENT_NAME === 'test' && urlParams.has('rtir') && urlParams.get('rtir') === environment.HAS_UUID_REMOVE_RTIR) {
      requestUrl.searchParams.set('rtir', environment.HAS_UUID_REMOVE_RTIR);
    }

    return this.http.post(requestUrl.href, data, { headers: this.defaultHttpHeaders })
      .toPromise()
      .then(this.extractData)
      .catch(this.extractData);
  }

  async SIGN_UP(data: any): Promise<any> {
    try {
      const response = await this.makePostRequest('sign-up', data);
      return this.extractData(response);
    } catch (res) {
      return this.extractData(res);
    }
  }

  async SIGN_IN(data: any): Promise<any> {
    try {
      const response = await this.makePostRequest('sign-in', data);
      this.localstorage.delete("form-data-financial-information");
      this.localstorage.delete("form-data-personal-information");
      this.localstorage.delete("form-data-fill-vinculation");
      return this.extractData(response);
    } catch (res) {
      return this.extractData(res);
    }
  }

  private extractData(res: any): any {
    return res;
  }
}